import React, { Component } from 'react'
import { connect } from 'react-redux'
import FulfilmentBox from './FulfilmentBox'
import { updateCisCookieStatus } from '../../actionCreators/storeLocator/storeLocatorActionCreators'
import localiseFulfilment from '../../actionCreators/localiseFulfilment/localiseFulfilmentActionCreators'
import { getAlternativeStore } from '../../actionCreators/localiseFulfilment/AlternativeStoreActionCreators'

class FulfilmentBoxContainer extends Component {
  render = () => <FulfilmentBox {...this.props} />
}

const mapPropsToFulfilmentPayload = props => {
  const { attributes, quantity, variants } = props
  const { partNumber } = attributes

  const fulfilmentParams = {
    partNumber,
    quantity,
    variants
  }
  return fulfilmentParams
}

const mapStateToProps = (state, ownProps) => {
  const {
    storeLocator,
    featuredProducts = {},
    bazaarVoiceReview = {},
    bazaarVoiceQuestionAnswer = {},
    alternatives = {},
    productStore = {},
    specialOffersCreator = {}
  } = state
  const { attributes = {} } = ownProps
  const { data: storeLocatorData, errorDetail, meta } = storeLocator
  const { initialised } = meta
  const fulfilmentPayload = mapPropsToFulfilmentPayload(ownProps)
  const featuredProductsStore = featuredProducts.data[attributes.partNumber] || {}
  const bazaarVoiceReviewStore = bazaarVoiceReview.data || {}
  const bazaarVoiceQuestionAnswerStore = bazaarVoiceQuestionAnswer.data || {}
  const alternativesStore = alternatives.data[attributes.partNumber] || {}

  const props = {
    isStoreLocatorInitialised: initialised,
    fulfilmentPayload,
    haslocaliseFfmFailed: !!errorDetail,
    storeLocator: storeLocatorData,
    currentSearchTerm: decodeURIComponent(storeLocatorData.currentSearchTerm),
    featuredProductsStore,
    bazaarVoiceReviewStore,
    bazaarVoiceQuestionAnswerStore,
    alternativesStore,
    productStore,
    attributes: productStore.data.attributes,
    specialOffersCreator: specialOffersCreator.data
  }
  return props
}

const mapDispatchToProps = dispatch => {
  const props = {
    updateCisCookieStatus: payload => dispatch(updateCisCookieStatus(payload)),
    localiseFulfilment: payload => dispatch(localiseFulfilment(payload)),
    getAlternativeStore: payload => dispatch(getAlternativeStore(payload))
  }
  return props
}

export default connect(mapStateToProps, mapDispatchToProps)(FulfilmentBoxContainer)
export { FulfilmentBoxContainer, mapPropsToFulfilmentPayload, mapStateToProps }
